<script>
export default {
  components: {},
  methods: {},
  props: ["component", "handler"],
  data: function () {
    return {};
  },
  computed: {
    progress: function () {
      let start = this.component.now - this.component.start_at;
      let end = this.component.expire_at - this.component.start_at;

      return Math.min(100, (start * 100) / end);
    },
    progressDelete: function () {
      let start = this.component.now - this.component.expire_at;
      let end = this.component.delete_at - this.component.expire_at;

      return Math.min(100, (start * 100) / end);
    },
  },
};
</script>

<template>
  <div class="home24-plan home24-box">
    <div class="home24-plan-left">
      <div class="home24-plan-label">
        {{ component.current_plan }}
        <span class="free" v-if="component.is_free">{{ $vt("Free") }}</span
        ><span class="expired" v-if="component.expired">{{ $vt("Expired") }}</span>
      </div>
      <div
        class="home24-plan-dates-and-jauge"
        v-if="
          component.start_at &&
          component.start_at != 'null' &&
          component.expire_at &&
          component.expire_at != 'null'
        "
      >
        <div class="home24-plan-dates">
          <div class="home24-plan-dates-start-at">
            {{ (component.start_at * 1000) | angularFilter("MMMM dd", "date") }}
          </div>
          <div class="home24-plan-dates-delete-at" v-if="component.expired">
            {{
              (component.delete_at * 1000)
                | angularFilter("MMMM dd, yyyy", "date")
            }}
          </div>
          <div
            class="home24-plan-dates-delete-at"
            v-else-if="component.next_session"
          >
            {{
              (component.next_session.expire_at * 1000)
                | angularFilter("MMMM dd, yyyy", "date")
            }}
          </div>
          <div class="home24-plan-dates-expire-at" v-else>
            {{
              (component.expire_at * 1000)
                | angularFilter("MMMM dd, yyyy", "date")
            }}
          </div>
        </div>
        <div class="home24-plan-jauges">
          <div class="home24-plan-jauge">
            <div
              class="fill"
              :class="{
                warning: !component.next_session && progress > 75,
                danger: !component.next_session && progress > 99,
              }"
              :style="{ width: progress + '%' }"
            ></div>
          </div>
          <div class="home24-plan-jauge delete-at" v-if="component.expired">
            <div
              class="fill danger"
              :style="{ width: progressDelete + '%' }"
            ></div>
          </div>
          <div
            class="home24-plan-jauge next-session"
            v-if="component.next_session"
          ></div>
        </div>
        <div class="home24-plan-content-deleted" v-if="component.expired">
          {{ $vt("All content will be deleted the") }}
          {{
            (component.delete_at * 1000) | angularFilter("d of MMMM", "date")
          }}
        </div>
        <div
          class="home24-plan-content-next-session"
          v-if="component.next_session"
        >
          {{ $vt("renew") }}
        </div>
      </div>
    </div>
    <f-button type="primary" href="#/purchase"
      >{{ $vt("Upgrade") }} <f-icon icon="fa6-circle-arrow-up"></f-icon
    ></f-button>
  </div>
</template>

<style lang="scss">
.home24-plan {
  display: flex;
  gap: 16px;

  .f-button {
    align-self: center;
    font-weight: 400;
    padding: 8px 8px 8px 16px;
    .f-icon {
      font-size: 20px;
    }
  }
  .home24-plan-left {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    align-items: flex-start;

    .home24-plan-dates-and-jauge {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      gap: 4px;
      width: 100%;
    }

    .home24-plan-jauges {
      display: flex;
      width: 100%;
      .home24-plan-jauge {
        flex: 1 1 50%;
        display: flex;
        height: 8px;
        border-radius: 4px;
        background-color: var(--navigation-a10);
        position: relative;

        > .fill {
          border-radius: 4px;
          background-color: var(--primary);
          height: 100%;

          &.warning {
            background-color: var(--notice);
          }

          &.danger {
            background-color: var(--negative);
          }
        }

        &.delete-at:before {
          position: absolute;
          content: "";
          width: 0;
          height: 16px;
          left: 0;
          top: 0;
          margin-top: -3px;
          margin-left: -3px;
        
          border: 1px dashed var(--white-a75);
        }

        &.next-session::before {
          position: absolute;
          content: "";
          width: 0;
          height: 16px;
          left: 0;
          top: 0;
          margin-top: -3px;
          margin-left: -3px;

          border: 1px dashed var(--white-a75);
        }
      }
    }

    .home24-plan-content-deleted,
    .home24-plan-content-next-session {
      font-family: Lato;
      font-size: 12px;
      font-weight: 700;
      line-height: 15px;
      text-align: center;
      color: var(--white-a75);
    }

    .home24-plan-label {
      display: flex;
      gap: 8px;
      align-items: center;
      color: var(--white-a75);
      text-align: center;
      font-family: Lato;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 0.32px;
      text-transform: uppercase;

      span {
        color: var(--white-a75);
        padding: 0 6px;
        font-family: Lato;
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: lowercase;
        border-radius: 24px;
        align-self: normal;
        display: flex;
        align-items: center;
        &.free {
          background-color: var(--navigation);
        }

        &.expired {
          background-color: var(--negative);
        }
      }
    }
    .home24-plan-dates {
      width: 100%;
      display: flex;
      color: var(--white-a75);
      font-family: Lato;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 125%; /* 15px */

      .home24-plan-dates-expire-at,
      .home24-plan-dates-delete-at {
        margin-left: auto;
      }
    }
  }
}
</style>